export default "<div class=\"main-wrapper\">\n  <p>\n    Willkommen bei Tool Time\n  </p>\n</div>\n";